import { formatDateFunc } from '@op/utils/time';
import { percentageFormat, reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';
import { Table } from 'tea-component';
import { useIntl } from 'umi';
const { scrollable } = Table.addons;
export function ReviewsTable({
  columns = [
    { text: 'Date', value: 'time', isDate: true, align: 'left' },
    { text: 'Positive', value: 'positive' },
    { text: 'Negative', value: 'negative' },
    { text: 'Positive%', value: 'score', isScore: true },
  ],
  filter,
  recordKey = 'time',
  records,
  height = 300,
}: {
  columns?: Array<{
    text: string;
    value: string;
    isDate?: boolean;
    isScore?: boolean;
    width?:number;
    align?: 'left' | 'right';
    format?: (value: any) => any;
  }>;
  filter: any;
  recordKey?: string;
  records: Array<any>;
  height?: number;
}) {
  const { formatMessage } = useIntl();

  const tableColumns = useMemo(() => {
    const formatDate = formatDateFunc(filter.date_type);
    return columns.map(
      ({ text, value, isDate, isScore, format, align = 'right', width }: any) => {
        let formatFunc: any = isScore ? percentageFormat : reviewsFormat;
        if (isDate) {
          formatFunc = formatDate;
        }
        if (format) {
          formatFunc = format;
        }
        return {
          key: value,
          align,
          width,
          header: formatMessage({ id: text }),
          render: (row: any) => {
            let text = row[value];
            return <div>{formatFunc(text)}</div>;
          },
        };
      },
    );
  }, [formatMessage]);

  return (
    <Table
      columns={tableColumns}
      recordKey={recordKey}
      records={records}
      addons={[
        scrollable({
          maxHeight: height,
          minWidth: 566,
        }),
      ]}
    ></Table>
  );
}
